<template lang="pug">
  .fields-preview-section(v-if="fields.length > 0")
    .fields-preview-section__title {{title}}
    .field-preview(v-for="(field, index) in fields" :key="field.jsonPath+index")
      .field-path
        p.path {{field.label}}
      .field-changes
        .row
          label.label Original Value
          row-creator(:item="field" :value="field.getValue ? field.getValue(field.oldValue) : field.oldValue")
        .row
          label.label Proposed Value
          row-creator(:item="field" :value="field.getValue ? field.getValue(field.newValue) : field.newValue")
        .row(v-if="field.comment")
          label.label Comment
          p.comment {{field.comment}}
</template>
<script>

import RowCreator from '@/components/record-details/table-components/RowCreator'
import LeiInfoLabel from '@/components/lei-components/LeiInfoLabel'

export default {
  components: {
    LeiInfoLabel,
    RowCreator,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    fields: {
      type: Array,
      required: true,
    },
  },
}
</script>
<style lang="stylus">
  @import "../../assets/styles/variables.styl"
  .fields-preview-section
    flex-direction column
    margin-bottom 10px
    padding 0 5px
    background $primary-color-light-2

    &__title
      line-height 40px
      margin-bottom 10px
      font-size 1rem
      font-weight 600

    .field-preview
      width 100%
      display flex
      flex-direction column
      margin 5px 0
      border 1px solid $default-color-light-1
      background white

      .field-path
        border-bottom 1px solid $default-color-light-1
        padding 10px
        display flex

        .path
          font-size 1rem
          color $default-color-bold

      .field-changes
        padding 10px
        display flex
        flex-direction column
        flex 1

        .row
          margin-bottom 10px

          &:last-child
            margin-bottom 0

        .column
          justify-content center
          align-items flex-start
          flex-direction column

        .label
          font-weight 700
          margin-bottom 5px

        .label, .value, .comment
          display flex
          font-size 0.9rem
          line-height 1.1rem
          min-height 1.1rem

        .comment, .value
          border-left 2px solid $default-color-light-1
          padding-left 5px

        .value
          color $default-color-bold-1
          font-weight 500

          &.link
            color $default-color-bold-1
            font-weight 500
            cursor pointer
            line-height 1.5rem
            border-bottom 1px solid $info-color
            transition all .2s ease

            &:hover
              color $primary-color
              border-bottom 1px solid $primary-color

          &.n-a
            color $default-color-middle

          &.status
            font-size 85%
            display flex
            align-items center

            .status-icon
              font-size 125%
              margin-right 8px

  @media (min-width: $mobile)
    .fields-preview-section
      .field-preview
        flex-direction row

        .field-path
          border-bottom none
          border-right 1px solid $default-color-light-1
          width 200px

</style>



// WEBPACK FOOTER //
// src/components/challenge-components/ChallengePreviewSection.vue